import { type RollDiceResponseType } from '../types/dice-game';

const getMainRollDiceAnaliticReward = (
  response: RollDiceResponseType,
): null | {
  reward_type: string;
  reward: Array<{ [field: string]: unknown }>;
} => {
  const posibleRewards = ['Box', 'Energy', 'dice'];
  const cellType = response.cellType;
  const multiplier = response.rollPower;

  if (!posibleRewards.includes(cellType)) {
    return null;
  }

  return {
    reward_type: cellType as string,
    reward:
      cellType === 'Box'
        ? [{ ...response.reward }]
        : cellType === 'Energy'
          ? [{ energy: 2 * multiplier }]
          : [{ dice: 2 * multiplier }],
  };
};

export { getMainRollDiceAnaliticReward };
